import Vue from "vue";
import Router from "vue-router";

// Containers
import Dashboard from "../views/dashboard/Dashboard";
import Home from "../views/admin/Home";
import TemplateAuthenticated from "../containers/TemplateAuthenticated";
import TemplateUnauthenticated from "../containers/TemplateUnauthenticated";
import TemplateAuthenticatedAdmin from "../containers/TemplateAuthenticatedAdmin.vue";

import routerKeys from "../store/router-keys";
import constants from "@/_consts";
import dashboardNav from "../_nav";
import adminRoute from "../_admin-nav";

Vue.use(Router);

function loadDynamicView(viewPath) {
  return () =>
    import(/* webpackChunkName: "views-[request]" */ `@/views/${viewPath}`);
}

const router = new Router({
  mode: "hash",
  linkActiveClass: "active",
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: "/",
      component: TemplateAuthenticated,
      reports: dashboardNav.items.clientAdminHome.url,
      meta: {
        requiresAuth: true,
        panel: constants.panels.client
      },
      children: [
        {
          path: dashboardNav.items.clientAdminHome.url,
          name: dashboardNav.items.clientAdminHome.name,
          component: Dashboard
        },
        {
          path: dashboardNav.items.programs.url,
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "",
              name: dashboardNav.items.programs.name,
              component: loadDynamicView("programs/ClientProgramPage")
            },
            {
              path: dashboardNav.items.programs.children.program_create.url,
              name: dashboardNav.items.programs.children.program_create.name,
              component: loadDynamicView("programs/ClientProgramCreatePage")
            },
            {
              path: dashboardNav.items.programs.children.program_info.url,
              name: dashboardNav.items.programs.children.program_info.name,
              component: loadDynamicView("admin/Program/ProgramEditPage")
            },
            {
              path: dashboardNav.items.programs.children.program_date.url,
              name: dashboardNav.items.programs.children.program_date.name,
              component: loadDynamicView("admin/Program/ProgramEditDatePage")
            },
            {
              path: dashboardNav.items.programs.children.program_structure_points.url,
              name: dashboardNav.items.programs.children.program_structure_points.name,
              component: loadDynamicView("admin/Program/ProgramStructurePointsPage")
            },
            {
              path: dashboardNav.items.programs.children.program_milestone_settings.url,
              name: dashboardNav.items.programs.children.program_milestone_settings.name,
              component: loadDynamicView("admin/Program/ProgramMilestoneSettingsPage")
            },
            {
              path: dashboardNav.items.programs.children.program_milestone_rewards_completion.url,
              name: dashboardNav.items.programs.children.program_milestone_rewards_completion.name,
              component: loadDynamicView("admin/Program/ProgramMilestoneCompletionRewardsPage")
            },
            {
              path: dashboardNav.items.programs.children.program_outcomes.url,
              name: dashboardNav.items.programs.children.program_outcomes.name,
              component: loadDynamicView("admin/Program/ProgramOutcomesPage")
            },
            {
              path: dashboardNav.items.programs.children.program_cohorts.url,
              name: dashboardNav.items.programs.children.program_cohorts.name,
              component: loadDynamicView("admin/Program/ProgramCohortsPage")
            },
            {
              path:
                dashboardNav.items.programs.children.program_appeals_form.url,
              name:
                dashboardNav.items.programs.children.program_appeals_form.name,
              component: loadDynamicView("admin/Program/ProgramAppealsFormPage")
            },
            {
              path: dashboardNav.items.programs.children.program_tobacco.url,
              name: dashboardNav.items.programs.children.program_tobacco.name,
              component: loadDynamicView("admin/Program/ProgramTobaccoPage")
            },
            {
              path: dashboardNav.items.programs.children.program_points.url,
              name: dashboardNav.items.programs.children.program_points.name,
              component: loadDynamicView("admin/Program/ProgramPointsPage")
            },
            {
              path:
                dashboardNav.items.programs.children.program_level_rewards.url,
              name:
                dashboardNav.items.programs.children.program_level_rewards.name,
              component: loadDynamicView(
                "admin/Program/ProgramLevelRewardsPage"
              )
            },
            {
              path: dashboardNav.items.programs.children.program_summary.url,
              name: dashboardNav.items.programs.children.program_summary.name,
              component: loadDynamicView("admin/Program/ProgramSummaryPage")
            },
            {
              path: dashboardNav.items.programs.children.program_activity.url,
              name: dashboardNav.items.programs.children.program_activity.name,
              component: loadDynamicView(
                "admin/Program/ProgramCalendarActivitiesPage"
              )
            },
            {
              path:
                dashboardNav.items.programs.children.program_level_activities
                  .url,
              name:
                dashboardNav.items.programs.children.program_level_activities
                  .name,
              component: loadDynamicView(
                "admin/Program/ProgramRequiredActivitiesPage"
              )
            },
            {
              path:
                dashboardNav.items.programs.children.program_ras_activities.url,
              name:
                dashboardNav.items.programs.children.program_ras_activities
                  .name,
              component: loadDynamicView(
                "admin/Program/ProgramRASActivitiesPage"
              )
            },
            {
              path: dashboardNav.items.programs.children.program_ras_paths.url,
              name: dashboardNav.items.programs.children.program_ras_paths.name,
              component: loadDynamicView("admin/Program/ProgramRASPathsPage")
            },
            {
              path:
                dashboardNav.items.programs.children.program_level_paths.url,
              name:
                dashboardNav.items.programs.children.program_level_paths.name,
              component: loadDynamicView("admin/Program/ProgramLevelPathsPage")
            },
            {
              path:
                dashboardNav.items.programs.children.program_level_practices
                  .url,
              name:
                dashboardNav.items.programs.children.program_level_practices
                  .name,
              component: loadDynamicView(
                "admin/Program/ProgramLevelPracticesPage"
              )
            },
            {
              path:
                dashboardNav.items.programs.children.program_activity_view.url,
              name:
                dashboardNav.items.programs.children.program_activity_view.name,
              component: loadDynamicView(
                "admin/Program/ProgramActivityViewPage"
              )
            },
            {
              path:
                dashboardNav.items.programs.children.program_level_activity_view
                  .url,
              name:
                dashboardNav.items.programs.children.program_level_activity_view
                  .name,
              component: loadDynamicView(
                "admin/Program/ProgramActivityViewPage"
              )
            },
            {
              path:
                dashboardNav.items.programs.children.program_collections.url,
              name:
                dashboardNav.items.programs.children.program_collections.name,
              component: loadDynamicView("admin/Program/ProgramCollectionsPage")
            }
          ]
        },
        {
          path: dashboardNav.items.incentiveProcessing.url,
          name: dashboardNav.items.incentiveProcessing.name,
          component: loadDynamicView("incentive-processing/IncentiveProcessing")
        },
        {
          path: dashboardNav.items.sisense.url,
          name: dashboardNav.items.sisense.name,
          component: loadDynamicView("sisense/Sisense")
        },
        // {
        //   path: '/report',
        //   name: 'report',
        //   component: loadDynamicView('report/Report')
        // },
        {
          path: dashboardNav.items.extracts.url,
          name: dashboardNav.items.extracts.name,
          component: loadDynamicView("extracts/Extracts")
        },
        {
          path: dashboardNav.items.faqs.url,
          name: dashboardNav.items.faqs.name,
          component: loadDynamicView("faqs/Faqs")
        },
        {
          path: dashboardNav.items.userManagement.path,
          name: dashboardNav.items.userManagement.name,
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: dashboardNav.items.userManagement.children.profile.path,
              name: dashboardNav.items.userManagement.children.profile.name,
              component: loadDynamicView("user/Management")
            },
            {
              path:
                dashboardNav.items.userManagement.children.changePassword.path,
              name:
                dashboardNav.items.userManagement.children.changePassword.name,
              component: loadDynamicView("user/Password")
            }
          ]
        },
        {
          path: "/employers",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "",
              name: "employer-list",
              component: loadDynamicView("employers/Employer")
            },
            {
              path: "add",
              name: "add-employer",
              component: loadDynamicView("employers/AddEditEmployer")
            },
            {
              path: ":id/edit",
              name: "edit-employer",
              component: loadDynamicView("employers/AddEditEmployer")
            }
          ]
        },
        {
          path: dashboardNav.items.eligibility.url,
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "",
              name: dashboardNav.items.eligibility.name,
              component: loadDynamicView("employees/EligiblePopulation")
            },
            {
              path:
                dashboardNav.items.eligibility.children.add_new_employee.url,
              name:
                dashboardNav.items.eligibility.children.add_new_employee.name,
              component: loadDynamicView("employees/AddOrEditEmployee")
            },
            {
              path: dashboardNav.items.eligibility.children.edit_employee.url,
              name: dashboardNav.items.eligibility.children.edit_employee.name,
              component: loadDynamicView("employees/AddOrEditEmployee")
            },
            {
              path: dashboardNav.items.eligibility.children.reward_history.url,
              name: dashboardNav.items.eligibility.children.reward_history.name,
              component: loadDynamicView("employees/EmployeeRewardHistory")
            }
          ]
        },
        {
          path: dashboardNav.items.userProvisioning.url,
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "",
              name: dashboardNav.items.userProvisioning.name,
              component: loadDynamicView(
                "user-provisioning/client-admins/ClientAdmins"
              )
            },
            {
              path:
                dashboardNav.items.userProvisioning.children.clientAdminsAdd
                  .path,
              name:
                dashboardNav.items.userProvisioning.children.clientAdminsAdd
                  .name,
              component: loadDynamicView(
                "user-provisioning/client-admins/AddEdit"
              )
            },
            {
              path:
                dashboardNav.items.userProvisioning.children.clientAdminsEdit
                  .path,
              name:
                dashboardNav.items.userProvisioning.children.clientAdminsEdit
                  .name,
              component: loadDynamicView(
                "user-provisioning/client-admins/AddEdit"
              )
            },
            {
              path:
                dashboardNav.items.userProvisioning.children.needsReview.path,
              name:
                dashboardNav.items.userProvisioning.children.needsReview.name,
              component: loadDynamicView(
                "user-provisioning/needs-review/NeedsReview"
              )
            },
            {
              path: dashboardNav.items.userProvisioning.children.changeLog.path,
              name: dashboardNav.items.userProvisioning.children.changeLog.name,
              component: loadDynamicView(
                "user-provisioning/change-log/ChangeLog"
              )
            }
          ]
        }
      ]
    },
    {
      path: adminRoute.path,
      name: adminRoute.name,
      component: TemplateAuthenticatedAdmin,
      meta: {
        requiresAuth: true,
        panel: constants.panels.admin
      },
      children: [
        {
          path: adminRoute.items.home.url,
          name: adminRoute.items.home.name,
          component: Home
        },
        {
          path: adminRoute.items.client.url,
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "",
              name: adminRoute.items.client.name,
              component: loadDynamicView("admin/Client/Clients")
            },
            {
              path: adminRoute.items.client.children.add_new_client.url,
              name: adminRoute.items.client.children.add_new_client.name,
              component: loadDynamicView("admin/Client/AddClient")
            },
            {
              path: adminRoute.items.client.children.edit_client.url,
              name: adminRoute.items.client.children.edit_client.name,
              component: loadDynamicView("admin/Client/AddClient")
            },
            {
              path: adminRoute.items.client.children.client_rewards_setting.url,
              name:
                adminRoute.items.client.children.client_rewards_setting.name,
              component: loadDynamicView("admin/Client/ClientRewardsSetting")
            }
          ]
        },
        {
          path: adminRoute.items.employee.url,
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "",
              name: adminRoute.items.employee.name,
              component: loadDynamicView("employees/EligiblePopulation")
            },
            {
              path: adminRoute.items.employee.children.add_new_employee.url,
              name: adminRoute.items.employee.children.add_new_employee.name,
              component: loadDynamicView("employees/AddOrEditEmployee")
            },
            {
              path: adminRoute.items.employee.children.edit_employee.url,
              name: adminRoute.items.employee.children.edit_employee.name,
              component: loadDynamicView("employees/AddOrEditEmployee")
            },
            {
              path: adminRoute.items.employee.children.reward_history.url,
              name: adminRoute.items.employee.children.reward_history.name,
              component: loadDynamicView("employees/EmployeeRewardHistory")
            },
            {
              path: adminRoute.items.employee.children.history.url,
              name: adminRoute.items.employee.children.history.name,
              component: loadDynamicView("employees/EmployeeHistory")
            }
          ]
        },
        {
          path: adminRoute.items.data_feeds.url,
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "",
              name: adminRoute.items.data_feeds.name,
              component: loadDynamicView("admin/DataFeeds/ClientSFTPs")
            },
            {
              name: adminRoute.items.data_feeds.children.add_client_sftp.name,
              path: adminRoute.items.data_feeds.children.add_client_sftp.url,
              component: loadDynamicView("admin/DataFeeds/AddClientSFTP")
            },
            {
              name: adminRoute.items.data_feeds.children.edit_client_sftp.name,
              path: adminRoute.items.data_feeds.children.edit_client_sftp.url,
              component: loadDynamicView("admin/DataFeeds/AddClientSFTP")
            },
            {
              path: adminRoute.items.data_feeds.children.pgp_certificate.url,
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              children: [
                {
                  path: "",
                  name:
                    adminRoute.items.data_feeds.children.pgp_certificate.name,
                  component: loadDynamicView("admin/DataFeeds/PGPCertificate")
                },
                {
                  path:
                    adminRoute.items.data_feeds.children.pgp_certificate
                      .children.add_pgp_certificate.url,
                  name:
                    adminRoute.items.data_feeds.children.pgp_certificate
                      .children.add_pgp_certificate.name,
                  component: loadDynamicView(
                    "admin/DataFeeds/AddEditPgpCertificate"
                  )
                },
                {
                  path:
                    adminRoute.items.data_feeds.children.pgp_certificate
                      .children.edit_pgp_certificate.url,
                  name:
                    adminRoute.items.data_feeds.children.pgp_certificate
                      .children.edit_pgp_certificate.name,
                  component: loadDynamicView(
                    "admin/DataFeeds/AddEditPgpCertificate"
                  )
                }
              ]
            },
            {
              path: adminRoute.items.data_feeds.children.file_source.url,
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              children: [
                {
                  path: "",
                  name: adminRoute.items.data_feeds.children.file_source.name,
                  component: loadDynamicView("admin/DataFeeds/FileSources")
                },
                {
                  path:
                    adminRoute.items.data_feeds.children.file_source.children
                      .add_file_source.url,
                  name:
                    adminRoute.items.data_feeds.children.file_source.children
                      .add_file_source.name,
                  component: loadDynamicView(
                    "admin/DataFeeds/AddEditFileSource"
                  )
                },
                {
                  path:
                    adminRoute.items.data_feeds.children.file_source.children
                      .edit_file_source.url,
                  name:
                    adminRoute.items.data_feeds.children.file_source.children
                      .edit_file_source.name,
                  component: loadDynamicView(
                    "admin/DataFeeds/AddEditFileSource"
                  )
                }
              ]
            },
            {
              path: adminRoute.items.data_feeds.children.data_transaction.url,
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              children: [
                {
                  path: "",
                  name:
                    adminRoute.items.data_feeds.children.data_transaction.name,
                  component: loadDynamicView("admin/DataFeeds/Transactions")
                },
                {
                  path: adminRoute.items.data_feeds.children.data_transaction
                    .children.transaction_detail.url,
                  name: adminRoute.items.data_feeds.children.data_transaction
                    .children.transaction_detail.name,
                  component: loadDynamicView('admin/DataFeeds/TransactionDetail')
                }
              ]
            }
          ]
        },
        {
          path: adminRoute.items.data_feeds.children.columnMapping.url,
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "",
              name: adminRoute.items.data_feeds.children.columnMapping.name,
              component: loadDynamicView("admin/ColumnMapping/ColumnMappings")
            },
            {
              path:
                adminRoute.items.data_feeds.children.columnMapping.children.add
                  .url,
              name:
                adminRoute.items.data_feeds.children.columnMapping.children.add
                  .name,
              component: loadDynamicView(
                "admin/ColumnMapping/AddEditColumnMapping"
              )
            },
            {
              path:
                adminRoute.items.data_feeds.children.columnMapping.children.edit
                  .url,
              name:
                adminRoute.items.data_feeds.children.columnMapping.children.edit
                  .name,
              component: loadDynamicView(
                "admin/ColumnMapping/AddEditColumnMapping"
              )
            }
          ]
        },
        {
          path: adminRoute.items.emailTemplate.url,
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "",
              name: adminRoute.items.emailTemplate.name,
              component: loadDynamicView("admin/EmailTemplate/EmailTemplates")
            },
            {
              path:
                adminRoute.items.emailTemplate.children.add_email_template.url,
              name:
                adminRoute.items.emailTemplate.children.add_email_template.name,
              component: loadDynamicView(
                "admin/EmailTemplate/AddOrEditEmailTemplate"
              )
            },
            {
              path:
                adminRoute.items.emailTemplate.children.edit_email_template.url,
              name:
                adminRoute.items.emailTemplate.children.edit_email_template
                  .name,
              component: loadDynamicView(
                "admin/EmailTemplate/AddOrEditEmailTemplate"
              )
            }
          ]
        },
        {
          path: adminRoute.items.program.url,
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "",
              name: adminRoute.items.program.name,
              component: loadDynamicView("admin/Program/ProgramPage")
            },
            {
              path: adminRoute.items.program.children.program_template.url,
              name: adminRoute.items.program.children.program_template.name,
              component: loadDynamicView("admin/Program/ProgramTemplatePage")
            },
            {
              path: adminRoute.items.program.children.program_create.url,
              name: adminRoute.items.program.children.program_create.name,
              component: loadDynamicView("admin/Program/ProgramCreatePage")
            },
            {
              path: adminRoute.items.program.children.program_info.url,
              name: adminRoute.items.program.children.program_info.name,
              component: loadDynamicView("admin/Program/ProgramEditPage")
            },
            {
              path: adminRoute.items.program.children.program_date.url,
              name: adminRoute.items.program.children.program_date.name,
              component: loadDynamicView("admin/Program/ProgramEditDatePage")
            },
            {
              path:adminRoute.items.program.children.program_structure_points.url,
              name:adminRoute.items.program.children.program_structure_points.name,
              component: loadDynamicView("admin/Program/ProgramStructurePointsPage")
            },
            {
              path:adminRoute.items.program.children.program_milestone_settings.url,
              name:adminRoute.items.program.children.program_milestone_settings.name,
              component: loadDynamicView("admin/Program/ProgramMilestoneSettingsPage")
            },
            {
              path:adminRoute.items.program.children.program_milestone_rewards_completion.url,
              name:adminRoute.items.program.children.program_milestone_rewards_completion.name,
              component: loadDynamicView("admin/Program/ProgramMilestoneCompletionRewardsPage")
            },
            {
              path: adminRoute.items.program.children.program_outcomes.url,
              name: adminRoute.items.program.children.program_outcomes.name,
              component: loadDynamicView("admin/Program/ProgramOutcomesPage")
            },
            {
              path: adminRoute.items.program.children.program_cohorts.url,
              name: adminRoute.items.program.children.program_cohorts.name,
              component: loadDynamicView("admin/Program/ProgramCohortsPage")
            },
            {
              path: adminRoute.items.program.children.program_appeals_form.url,
              name: adminRoute.items.program.children.program_appeals_form.name,
              component: loadDynamicView("admin/Program/ProgramAppealsFormPage")
            },
            {
              path: adminRoute.items.program.children.program_tobacco.url,
              name: adminRoute.items.program.children.program_tobacco.name,
              component: loadDynamicView("admin/Program/ProgramTobaccoPage")
            },
            {
              path: adminRoute.items.program.children.program_points.url,
              name: adminRoute.items.program.children.program_points.name,
              component: loadDynamicView("admin/Program/ProgramPointsPage")
            },
            {
              path: adminRoute.items.program.children.program_level_rewards.url,
              name:
                adminRoute.items.program.children.program_level_rewards.name,
              component: loadDynamicView(
                "admin/Program/ProgramLevelRewardsPage"
              )
            },
            {
              path: adminRoute.items.program.children.program_summary.url,
              name: adminRoute.items.program.children.program_summary.name,
              component: loadDynamicView("admin/Program/ProgramSummaryPage")
            },
            {
              path: adminRoute.items.program.children.program_activity.url,
              name: adminRoute.items.program.children.program_activity.name,
              component: loadDynamicView(
                "admin/Program/ProgramCalendarActivitiesPage"
              )
            },
            {
              path:
                adminRoute.items.program.children.program_level_activities.url,
              name:
                adminRoute.items.program.children.program_level_activities.name,
              component: loadDynamicView(
                "admin/Program/ProgramRequiredActivitiesPage"
              )
            },
            {
              path:
                adminRoute.items.program.children.program_ras_activities.url,
              name:
                adminRoute.items.program.children.program_ras_activities.name,
              component: loadDynamicView(
                "admin/Program/ProgramRASActivitiesPage"
              )
            },
            {
              path: adminRoute.items.program.children.program_ras_paths.url,
              name: adminRoute.items.program.children.program_ras_paths.name,
              component: loadDynamicView("admin/Program/ProgramRASPathsPage")
            },
            {
              path: adminRoute.items.program.children.program_activity_view.url,
              name:
                adminRoute.items.program.children.program_activity_view.name,
              component: loadDynamicView(
                "admin/Program/ProgramActivityViewPage"
              )
            },
            {
              path: adminRoute.items.program.children.program_level_paths.url,
              name: adminRoute.items.program.children.program_level_paths.name,
              component: loadDynamicView("admin/Program/ProgramLevelPathsPage")
            },
            {
              path:
                adminRoute.items.program.children.program_level_practices.url,
              name:
                adminRoute.items.program.children.program_level_practices.name,
              component: loadDynamicView(
                "admin/Program/ProgramLevelPracticesPage"
              )
            },
            {
              path:
                adminRoute.items.program.children.program_level_activity_view
                  .url,
              name:
                adminRoute.items.program.children.program_level_activity_view
                  .name,
              component: loadDynamicView(
                "admin/Program/ProgramActivityViewPage"
              )
            },
            {
              path: adminRoute.items.program.children.program_reward_error.url,
              name: adminRoute.items.program.children.program_reward_error.name,
              component: loadDynamicView("admin/Basic/ProgramRewardErrorLog")
            },
            {
              path:
                adminRoute.items.program.children.program_reward_history.url,
              name:
                adminRoute.items.program.children.program_reward_history.name,
              component: loadDynamicView("admin/Basic/ProgramRewardHistory")
            },
            {
              path: adminRoute.items.program.children.program_collections.url,
              name: adminRoute.items.program.children.program_collections.name,
              component: loadDynamicView("admin/Program/ProgramCollectionsPage")
            }
          ]
        },
        {
          path: adminRoute.items.user.url,
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "",
              name: adminRoute.items.user.name,
              component: loadDynamicView("admin/User/User")
            },
            {
              path: adminRoute.items.user.children.add_user.url,
              name: adminRoute.items.user.children.add_user.name,
              component: loadDynamicView("admin/User/AddOrEditUser")
            },
            {
              path: adminRoute.items.user.children.edit_user.url,
              name: adminRoute.items.user.children.edit_user.name,
              component: loadDynamicView("admin/User/AddOrEditUser")
            },
            {
              path: adminRoute.items.user.children.role.url,
              name: adminRoute.items.user.children.role.name,
              component: loadDynamicView("admin/User/Roles")
            },
            {
              path: adminRoute.items.user.children.add_role.url,
              name: adminRoute.items.user.children.add_role.name,
              component: loadDynamicView("admin/User/AddOrEditRole")
            },
            {
              path: adminRoute.items.user.children.edit_role.url,
              name: adminRoute.items.user.children.edit_role.name,
              component: loadDynamicView("admin/User/AddOrEditRole")
            },
            {
              path: adminRoute.items.user.children.activity_log.url,
              name: adminRoute.items.user.children.activity_log.name,
              component: loadDynamicView("admin/User/ActivitiesLog")
            },
            {
              path: adminRoute.items.user.children.client_admin.url,
              name: adminRoute.items.user.children.client_admin.name,
              component: loadDynamicView(
                "user-provisioning/client-admins/ClientAdmins"
              )
            },
            {
              path: adminRoute.items.user.children.client_admin_add.url,
              name: adminRoute.items.user.children.client_admin_add.name,
              component: loadDynamicView(
                "user-provisioning/client-admins/AddEdit"
              )
            },
            {
              path: adminRoute.items.user.children.client_admin_edit.url,
              name: adminRoute.items.user.children.client_admin_edit.name,
              component: loadDynamicView(
                "user-provisioning/client-admins/AddEdit"
              )
            },
            {
              path:
                adminRoute.items.user.children.client_admin_need_reviews.url,
              name:
                adminRoute.items.user.children.client_admin_need_reviews.name,
              component: loadDynamicView(
                "user-provisioning/needs-review/NeedsReview"
              )
            },
            {
              path: adminRoute.items.user.children.client_admin_change_log.url,
              name: adminRoute.items.user.children.client_admin_change_log.name,
              component: loadDynamicView(
                "user-provisioning/change-log/ChangeLog"
              )
            }
          ]
        },
        {
          path: adminRoute.items.security.url,
          name: adminRoute.items.security.name,
          component: loadDynamicView("admin/Security")
        },
        {
          path: adminRoute.items.logs.url,
          name: adminRoute.items.logs.name,
          component: loadDynamicView("admin/Logs/Logs")
        },
        {
          path: adminRoute.items.userManagement.path,
          name: adminRoute.items.userManagement.name,
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: adminRoute.items.userManagement.children.profile.path,
              name: adminRoute.items.userManagement.children.profile.name,
              component: loadDynamicView("user/Management")
            },
            {
              path:
                adminRoute.items.userManagement.children.changePassword.path,
              name:
                adminRoute.items.userManagement.children.changePassword.name,
              component: loadDynamicView("user/Password")
            }
          ]
        }
      ]
    },
    {
      path: "/",
      component: TemplateUnauthenticated,
      children: [
        {
          path: routerKeys.login,
          name: "Login",
          component: loadDynamicView("login/Login")
        },
        {
          path: routerKeys.forgotPassword.url,
          name: routerKeys.forgotPassword.name,
          component: loadDynamicView("auth/ForgotPassword")
        },
        {
          path: routerKeys.createPwd.url,
          name: routerKeys.createPwd.name,
          component: loadDynamicView("create-password/CreatePassword")
        },
        {
          path: routerKeys.setupMFA.url,
          name: routerKeys.setupMFA.name,
          component: loadDynamicView("mfa/SetupMFA")
        },
        {
          path: routerKeys.validationCode.url,
          name: routerKeys.validationCode.name,
          component: loadDynamicView("mfa/ValidationMFACode")
        },
        {
          path: routerKeys.selectClient.url,
          name: routerKeys.selectClient.name,
          component: loadDynamicView("login/SelectClient")
        }
      ]
    },
    {
      path: "/not-found",
      name: "Not Found",
      component: { template: '<h1 style="color: white">Page not found!!!</h1>' } // TODO 404 page
    }
  ]
});

router.beforeEach((to, from, next) => {
  if (
    to.matched.some(record => record.meta.requiresAuth) &&
    !sessionStorage.getItem(constants.LOCAL_STORE.accessToken)
  ) {
    next({ path: routerKeys.login, query: { reports: to.fullPath } });
  } else if (!to.matched.length) {
    next({ path: "/not-found" });
  } else {
    const routeHasPanel = to.matched.find(
      record =>
        record && record.meta.panel && Object.keys(record.meta.panel).length > 0
    );
    if (
      routeHasPanel &&
      routeHasPanel.meta.panel === constants.panels.admin &&
      localStorage.getItem(constants.LOCAL_STORE.client)
    ) {
      localStorage.removeItem(constants.LOCAL_STORE.client);
    }
    next();
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js